import { render, staticRenderFns } from "./penfolds.vue?vue&type=template&id=09357226&scoped=true"
import script from "./penfolds.vue?vue&type=script&lang=js"
export * from "./penfolds.vue?vue&type=script&lang=js"
import style0 from "./penfolds.vue?vue&type=style&index=0&id=09357226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09357226",
  null
  
)

export default component.exports